import {
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem,
  Stack,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';

import FormattedMessages from '../../../../messages/admin/CustomerProfileMessages';
import {
  CountryInput,
  TextInput,
  FileInput,
  SelectInput,
  YesNoInput,
  CountryAutocompleteInput,
} from './Inputs';

const CompanyInfo = ({ profile, highlighted, enums, onChange, onDownload }) => {
  const [info, setInfo] = useState({});

  useEffect(() => {
    setInfo({ ...profile?.company } || {});
    console.log('company', profile?.company);
  }, [profile]);

  useEffect(() => {}, [highlighted]);

  const handleInputChange = (name, value, extra) => {
    const i = { ...info };
    console.log(name, value, i);
    i[name].value = value;
    if (name === 'country_registered') {
      i[name].country = extra;
    }

    setInfo(i);
    onChange('company', i);
  };

  return (
    <Grid container spacing={10} sx={{ width: '100%' }}>
      {/* Left Column */}
      <Grid sx={{ maxWidth: { md: 460 } }} size={{ xs: 12, lg: 6 }}>
        <Stack spacing={3}>
          {/* Country */}
          {info.country_registered?.visible && (
            <CountryInput
              id="country_registered"
              name="country_registered"
              label={FormattedMessages.country}
              value={info.country_registered?.value}
              required={info.country_registered?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            />
          )}
          {/* IP Address */}
          {info.ip_address?.visible && (
            <TextInput
              id="ip_address"
              name="ip_address"
              label={FormattedMessages.ipAddress}
              value={info.ip_address?.value}
              required={info.ip_address?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            />
          )}
          {/* Legal Name */}
          {info.company_legal_name?.visible && (
            <TextInput
              id="company_legal_name"
              name="company_legal_name"
              label={FormattedMessages.legalName}
              value={info.company_legal_name?.value}
              required={info.company_legal_name?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            />
          )}
          {/* Account Name */}
          {info.account_name?.visible && (
            <TextInput
              id="account_name"
              name="account_name"
              label={FormattedMessages.accountName}
              value={info.account_name?.value}
              required={info.account_name?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            />
          )}
          {/* Tax ID */}
          {info.registration_id?.visible && (
            <TextInput
              id="registration_id"
              name="registration_id"
              label={FormattedMessages.taxId}
              value={info.registration_id?.value}
              required={info.registration_id?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            />
          )}
          {/* Authority */}
          {info.proof_of_authority?.visible && (
            <FileInput
              id="proof_of_authority"
              name="proof_of_authority"
              label={FormattedMessages.authority}
              value={info.proof_of_authority?.value}
              required={info.proof_of_authority?.required}
              onChange={handleInputChange}
              onDownload={onDownload}
              highlighted={highlighted}
            />
          )}
          {/* Business Type */}
          {info.business_vertical?.visible && (
            <SelectInput
              id="business_vertical"
              name="business_vertical"
              label={FormattedMessages.businessType}
              value={info.business_vertical?.value}
              required={info.business_vertical?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            >
              {enums?.vertical &&
                Object.keys(enums.vertical).map((vertical) => (
                  <MenuItem key={vertical} value={vertical}>
                    {enums.vertical[vertical].displayName}
                  </MenuItem>
                ))}
            </SelectInput>
          )}
          {/* Product */}
          {info.business_product?.visible && (
            <TextInput
              id="business_product"
              name="business_product"
              label={FormattedMessages.product}
              value={info.business_product?.value}
              required={info.business_product?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            />
          )}
          {/* Authority */}
          {info.trademark_certificate?.visible && (
            <FileInput
              id="trademark_certificate"
              name="trademark_certificate"
              label={FormattedMessages.trademarkCertificate}
              value={info.trademark_certificate?.value}
              required={info.trademark_certificate?.required}
              onChange={handleInputChange}
              onDownload={onDownload}
              highlighted={highlighted}
            />
          )}
        </Stack>
      </Grid>

      {/* Right Column */}
      <Grid sx={{ maxWidth: { md: 460 } }} size={{ xs: 12, lg: 6 }}>
        <Stack spacing={3}>
          {/* Business Phone */}
          {info.business_phone?.visible && (
            <TextInput
              id="business_phone"
              name="business_phone"
              label={FormattedMessages.businessPhone}
              value={info.business_phone?.value}
              required={info.business_phone?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            />
          )}
          {/* Website */}
          {info.website?.visible && (
            <TextInput
              id="website"
              name="website"
              label={FormattedMessages.website}
              value={info.website?.value}
              required={info.website?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            />
          )}
          {/* Identifier Type */}
          {info.identifier_type?.visible && (
            <SelectInput
              id="identifier_type"
              name="identifier_type"
              label={FormattedMessages.identifierType}
              value={info.identifier_type?.value}
              required={info.identifier_type?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            >
              <MenuItem value="duns">DUNS</MenuItem>
              <MenuItem value="giin">GIIN</MenuItem>
              <MenuItem value="lei">LEI</MenuItem>
            </SelectInput>
          )}
          {/* Identifier Number */}
          {info.identifier_number?.visible && (
            <TextInput
              id="identifier_number"
              name="identifier_number"
              label={FormattedMessages.identifierNumber}
              value={info.identifier_number?.value}
              required={info.identifier_number?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            />
          )}
          {/* Entity Type */}
          {info.entity_type?.visible && (
            <SelectInput
              id="entity_type"
              name="entity_type"
              label={FormattedMessages.entityType}
              value={info.entity_type?.value}
              required={info.entity_type?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            >
              {enums?.entityType &&
                enums.entityType.map((type) => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
            </SelectInput>
          )}
          {/* Entity Type */}
          {info.stock_exchange?.visible && (
            <SelectInput
              id="stock_exchange"
              name="stock_exchange"
              label={FormattedMessages.stockExchange}
              value={info.stock_exchange?.value}
              required={info.stock_exchange?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            >
              {enums?.stockExchange &&
                enums.stockExchange.map((name) => (
                  <MenuItem key={name} value={name}>
                    {name}
                  </MenuItem>
                ))}
            </SelectInput>
          )}
          {/* Stock Exchange Symbol */}
          {info.stock_exchange_symbol?.visible && (
            <TextInput
              id="stock_exchange_symbol"
              name="stock_exchange_symbol"
              label={FormattedMessages.stockExchangeSymbol}
              value={info.stock_exchange_symbol?.value}
              required={info.stock_exchange_symbol?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            />
          )}
          {/* Brand Relationship */}
          {info.brand_relationship?.visible && (
            <SelectInput
              id="brand_relationship"
              name="brand_relationship"
              label={FormattedMessages.brandRelationship}
              value={info.brand_relationship?.value}
              required={info.brand_relationship?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            >
              {enums?.brandRelationship &&
                enums.brandRelationship.map((relationship) => (
                  <MenuItem key={relationship} value={relationship}>
                    {relationship}
                  </MenuItem>
                ))}
            </SelectInput>
          )}
          {/* Business Classification */}
          {info.business_classification?.visible && (
            <SelectInput
              id="business_classification"
              name="business_classification"
              label={FormattedMessages.businessClassification}
              value={info.business_classification?.value}
              required={info.business_classification?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            >
              <MenuItem value="direct">
                {FormattedMessages.businessClassDirect}
              </MenuItem>
              <MenuItem value="isv">
                {FormattedMessages.businessClassISV}
              </MenuItem>
            </SelectInput>
          )}
          {/* ISV Assigns Numbers */}
          {info.use_ro_numbers?.visible && (
            <YesNoInput
              id="use_ro_numbers"
              name="use_ro_numbers"
              label={FormattedMessages.isvAssignsNumbers}
              value={info.use_ro_numbers?.value}
              required={info.use_ro_numbers?.required}
              onChange={handleInputChange}
              tooltip={FormattedMessages.isvAssignsNumbersTooltip}
              highlighted={highlighted}
            />
          )}
          {/* Send Messages Internationally */}
          {info.send_international?.visible && (
            <YesNoInput
              id="send_international"
              name="send_international"
              label={FormattedMessages.sendMessagesInternationally}
              value={info.send_international?.value}
              required={info.send_international?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            />
          )}

          {/* which countries to send messages to */}
          {info.send_to_countries?.visible && (
            <CountryAutocompleteInput
              id="send_to_countries"
              name="send_to_countries"
              label={FormattedMessages.sendToCountries}
              value={info.send_to_countries?.value}
              required={info.send_to_countries?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            />
          )}
        </Stack>
      </Grid>

      {/* Left Column */}
      <Grid sx={{ maxWidth: { md: 460 } }} size={{ xs: 12, lg: 6 }}>
        <Stack spacing={3}>
          <Typography variant="h5" gutterBottom>
            {FormattedMessages.physicalAddress}
          </Typography>

          {/* Address 1 */}
          {info.address_1?.visible && (
            <TextInput
              id="address_1"
              name="address_1"
              label={FormattedMessages.address1}
              value={info.address_1?.value}
              required={info.address_1?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            />
          )}

          {/* Address 2 */}
          {info.address_2?.visible && (
            <TextInput
              id="address_2"
              name="address_2"
              label={FormattedMessages.address2}
              value={info.address_2?.value}
              required={info.address_2?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            />
          )}

          {/* City */}
          {info.city?.visible && (
            <TextInput
              id="city"
              name="city"
              label={FormattedMessages.city}
              value={info.city?.value}
              required={info.city?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            />
          )}

          {/* State */}
          {info.state?.visible && (
            <TextInput
              id="state"
              name="state"
              label={FormattedMessages.state}
              value={info.state?.value}
              required={info.state?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            />
          )}

          {/* Zip */}
          {info.postal_code?.visible && (
            <TextInput
              id="postal_code"
              name="postal_code"
              label={FormattedMessages.zip}
              value={info.postal_code?.value}
              required={info.postal_code?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            />
          )}

          {/* Country */}
          {info.country?.visible && (
            <CountryInput
              id="country"
              name="country"
              label={FormattedMessages.country}
              value={info.country?.value}
              required={info.country?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            />
          )}
        </Stack>
      </Grid>

      {/* Right Column */}
      <Grid sx={{ maxWidth: { md: 460 } }} size={{ xs: 12, lg: 6 }}>
        <Stack spacing={3}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={2}
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="h5">
              {FormattedMessages.postalAddress}
            </Typography>
            <FormControlLabel
              control={
                <Checkbox
                  name="billing_address_same"
                  size="small"
                  checked={!!info.billing_address_same?.value}
                  onChange={(e) =>
                    handleInputChange('billing_address_same', e.target.checked)
                  }
                />
              }
              label={FormattedMessages.billingAddressSameAsPhysical}
            />
          </Stack>

          {/* Address 1 */}
          {info.billing_address_1?.visible && (
            <TextInput
              id="billing_address_1"
              name="billing_address_1"
              label={FormattedMessages.address1}
              value={info.billing_address_1?.value}
              required={info.billing_address_1?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            />
          )}

          {/* Address 2 */}
          {info.billing_address_2?.visible && (
            <TextInput
              id="billing_address_2"
              name="billing_address_2"
              label={FormattedMessages.address2}
              value={info.billing_address_2?.value}
              required={info.billing_address_2?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            />
          )}

          {/* City */}
          {info.billing_city?.visible && (
            <TextInput
              id="billing_city"
              name="billing_city"
              label={FormattedMessages.city}
              value={info.billing_city?.value}
              required={info.billing_city?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            />
          )}

          {/* State */}
          {info.billing_state?.visible && (
            <TextInput
              id="billing_state"
              name="billing_state"
              label={FormattedMessages.state}
              value={info.billing_state?.value}
              required={info.billing_state?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            />
          )}

          {/* Zip */}
          {info.billing_postal_code?.visible && (
            <TextInput
              id="billing_postal_code"
              name="billing_postal_code"
              label={FormattedMessages.zip}
              value={info.billing_postal_code?.value}
              required={info.billing_postal_code?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            />
          )}

          {/* Country */}
          {info.billing_country?.visible && (
            <CountryInput
              id="billing_country"
              name="billing_country"
              label={FormattedMessages.country}
              value={info.billing_country?.value}
              required={info.billing_country?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            />
          )}
        </Stack>
      </Grid>
    </Grid>
  );
};

export default CompanyInfo;
